import { render } from "./lane-header.vue?vue&type=template&id=08b4d2c8&scoped=true"
import script from "./lane-header.vue?vue&type=script&lang=js"
export * from "./lane-header.vue?vue&type=script&lang=js"

import "./lane-header.vue?vue&type=style&index=0&id=08b4d2c8&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b4d2c8"]])

export default __exports__